export default {
  ERROR: {
    PROVISION: {
      INVALID_CUSTOMER: 'Identificação do callcenter não foi encontrado'
    }
  }
}
